module.exports = __webpack_public_path__ + "img/goIn.9c32fef1.svg";